import {
  schAloftDate,
  schAloftPrice,
  schHoaFeeFrequency,
  schPropertyInterest,
} from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schSubjectPropertyDetailsForm = z
  .object({
    zoning: z.string(),
    zoningCompliance: z.string(),
    parcelNumber: z.string(),
    hoa: z.string(),
    hoaFeeAmount: schAloftPrice,
    hoaFeeFrequency: schHoaFeeFrequency,
    legalDescription: z.string(),
    pud: z.boolean().default(false),
    propertyInterest: schPropertyInterest,
    propertyInterestOther: z.string(),
  })
  .partial()
  .superRefine((data, ctx) => {
    if (data.propertyInterest === 'Other') {
      if (!data.propertyInterestOther || data.propertyInterestOther.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required',
          path: ['propertyInterestOther'],
        });
      }
    }
  });

export type SubjectPropertyDetailsFormOutput = z.infer<typeof schSubjectPropertyDetailsForm>;

export const schOrderDetailsForm = z
  .object({
    effectiveDate: schAloftDate,
    intendedUsers: z.string(),
    intendedUse: z.string(),
    totalRenovationBudget: schAloftPrice,
  })
  .partial()
  .superRefine((data, ctx) => {
    if (!data.effectiveDate || data.effectiveDate.getYear() < 2020) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Effective Date must be present and greater or equal to 2020',
        path: ['effectiveDate'],
      });
    }
  });

export type SubjectPropertyDetailsForm = z.infer<typeof schSubjectPropertyDetailsForm>;

export type OrderDetailsFormOutput = z.infer<typeof schOrderDetailsForm>;
